
import * as XLSX from 'xlsx';
import React from "react";
import { EmployeeTeamVM } from "../Models/ViewModels";
import { Table } from 'rsuite';


export const handleDownloadAsExcel=(cachedTeamList:any)=>{

  const newData=cachedTeamList.map((row:any)=>{
    delete row.mapping_id
    
      return row;
  })
  const worksheet=XLSX.utils.json_to_sheet(newData);
  const workbook=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook,worksheet,"data");
  XLSX.write(workbook,{bookType:"xlsx",type:"binary"})
  XLSX.writeFile(workbook,"Data.xlsx")
  }
  
  
 export const isObjectUndefined = (obj: any): boolean => {

    if (obj === null) 
      return true;
    
    if (obj === '')
      return true;

    if(typeof obj === 'undefined')
        return true;

    return false;
      
  }

  export const stringToColor=(string:any)=> {
    let hash = 0;
    let i;
  
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

  
    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
   
    return color;
  }
  
  export const stringAvatar=(name: any)=> {
  
     
    return {
   
        style: {
            background: stringToColor(name),
         
          },
      children: `${name.split(' ')[0][0]}`,
      
    };
  
}



